import TurfCentroid from '@turf/centroid';
import {lineString, polygon} from '@turf/helpers';
import TurfCenterOfMass from '@turf/center-of-mass';
import TurfArea from '@turf/area';
import TurfEllipse from '@turf/ellipse';
import TurfCircle from '@turf/circle';
import TurfRotate from '@turf/transform-rotate';
import TurfBuffer from '@turf/buffer';
import TurfLength from '@turf/length';
import PolySmooth from '@turf/polygon-smooth';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import clickableMarker from "../utils/clickableMarker";
import DrawOptionsPanel from "../components/DrawOptionsPanel";
import OpacityPanel from "../components/OpacityPanel";
import React,{useRef, useState, useEffect} from "react";
import {Windmill }			from "@phosphor-icons/react";
import {rads2deg}			from "../utils/functions";
import html2canvas			from 'html2canvas';
import ToolTurbineDetail	from "../classes/ToolTurbineDetail";
import {ToolCable}			from "../classes/ToolCable";
import {ToolRoad}			from "../classes/ToolRoad";
import vindrApi				from "../utils/vindrapi";
import LayerTurbine			from "../classes/LayerTurbine";
import LayerCable			from "../classes/LayerCable";
import LayerRoad			from "../classes/LayerRoad";
import LayerBoundary		from "../classes/LayerBoundary";
import LayerCircles			from "../classes/LayerCircles";
import LayerEllipses			from "../classes/LayerEllipses";

import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Dropdown } from "react-bootstrap";
import Select from "react-select";

import MapboxDraw from "@mapbox/mapbox-gl-draw";

class drawUtils {
	
	windmill = '<svg xmlns="http://www.w3.org/2000/svg" class="windmill" width="16" height="16" fill="currentColor" viewBox="0 0 256 256"><path d="M224,224H182.94l-6.3-44.12,3.24,1.91a16,16,0,0,0,21.91-5.67l12-20.34a16,16,0,0,0-5.67-21.91l-35-20.61,40.69-69.13a16,16,0,0,0-5.67-21.91l-20.34-12a16,16,0,0,0-21.91,5.67l-20.61,35L76.12,10.22a16,16,0,0,0-21.91,5.67l-12,20.33a16,16,0,0,0,5.67,21.92l35,20.61L42.21,147.88a16,16,0,0,0,5.67,21.91l20.34,12a15.57,15.57,0,0,0,10.58,2L73.06,224H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16Zm-24-76.34L188,168l-69.13-40.69,12-20.35ZM179.66,24,200,36l-40.69,69.14L139,93.17ZM56,44.35,68,24,137.14,64.7l-12,20.35ZM76.34,168,56,156,96.69,86.86l20.36,12Zm12.88,56L98,162.8l12.77-21.7L159,169.5l7.79,54.5Z"></path></svg>';
	trash = '<svg xmlns="http://www.w3.org/2000/svg" class="trash" width="16" height="16" fill="currentColor" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="216" y1="56" x2="40" y2="56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="104" y1="104" x2="104" y2="168" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="152" y1="104" x2="152" y2="168" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>';

	tooltips = {};
	boundary = [];
	defaultColor = "#3bb2d0";
	defaultThickness = 2;
	currentSelectedDrawing = null;
	lastSelection = null;
	markers = [];
	
	previousPhotoMarker = null;

	constructor(map, draw, context){
		this.map = map;
		this.draw = draw;
		this.points = [];
		this.currentPosition = [];
		this.turbines = [];
		this.ellipses = [];
		this.circles = [];
		this.photos = [];
		this.context = context;
		this.ellipsesOrientation = 0;
		
		this.currentColor = this.defaultColor;
		this.currentThickness = this.defaultThickness;
		
		this.thicknessRange = React.createRef();
		this.colorRange = React.createRef();
		this.optionsPanel = React.createRef();
		
		document.addEventListener("keyup", this.onKeyUp.bind(this));
		
		this.setContextMenu();
		
	}
	onKeyUp(e){
		if(e.key && e.keyCode == 46) {
			this.draw.trash();
		}
		if(e.key && e.keyCode == 27) {
			this.draw.changeMode('simple_select');
		}
	}
	createPanel(e){
		if(this.panel){
			this.panel.classList.remove("draw_polygon", "draw_line_string");
		}
		else {
		
			this.areaPanel = document.createElement("span"); 
			this.areaPanel.classList.add("areaPanel");
			this.distancePanel = document.createElement("span");
			this.distancePanel.classList.add("distancePanel");
			this.panel = document.createElement("div");
			this.panel.appendChild(this.areaPanel);
			this.panel.appendChild(this.distancePanel);
			this.panel.classList.add("measure-panel");
			this.map._canvasContainer.nextSibling.querySelector(":scope > .mapboxgl-ctrl-bottom-left").appendChild(this.panel);
		}
		
		this.panel.classList.add(e.mode);
		this.updatePanel();
		
	}
	handleModeChange(e){
		if(e.mode == "draw_line_string" || e.mode == "draw_polygon"){
			//line drawing will start on next click
			//set click detection
			//set mousemove handler		
			this.points = [];
			this.currentPosition = [];
			this.createPanel(e);
			this.map.on('click', this.startMeasuring.bind(this));
			
		}
		if(e.mode == "simple_select"){
			//finish measuring
			//remove listeners
			this.finishMeasuring();
			
		}
		
		if(e.mode == "direct_select"){
			//finish measuring
			//remove listeners
			
		}
		
	}
	formatDistance(number) {
		if (number >= 1000)
			return (number / 1000.0).toFixed(2) + "<span>km</span>"
		else 
			return number.toFixed(2) + "<span>m</span>"
		
	}
	formatArea(number) {
		if (number >= 1000)
			return (number / 1000.0).toFixed(2) + "<span>km<sup>2</sup></span>"
		else 
			return number.toFixed(2) + "<span>m<sup>2</sup></span>"
		
	}
	startMeasuring(e){
		
		if(e.lngLat && e.lngLat.lat && e.lngLat.lng){
			this.points.push([e.lngLat.lng, e.lngLat.lat]);
		}
		this.map.on('mousemove', this.handleMouseMove.bind(this));
	}
	finishMeasuring(e){

		this.map.off('click', this.startMeasuring.bind(this));
		this.map.off('mousemove', this.handleMouseMove.bind(this));
		if(this.panel){
			this.panel.remove();
			delete this.panel;
		}

	}
	updatePanel(){
		
		
		var pointSet = [...this.points, [...this.currentPosition]];
		var distance = 0;
		var area = 0;
		if(this.points.length && pointSet.length){
			var line = lineString(pointSet);
			distance = TurfLength(line, {units: 'meters'});
		}

		if(this.points.length && pointSet.length>2){
			var poly = polygon([[...pointSet, [...this.points[0]]]]);
			area = TurfArea(poly);
		}
		
		this.distancePanel.innerHTML = this.formatDistance(distance);
		this.areaPanel.innerHTML = this.formatArea(area);
	}
	handleMouseMove(e){
		
		if(e.lngLat && e.lngLat.lat && e.lngLat.lng)
			this.currentPosition = [e.lngLat.lng, e.lngLat.lat];
		
		this.updatePanel();
		
	}
	handleEvent(e, updateFunction, tc){
		
		// handle deletions first
		if (e.type == 'draw.delete' && this.tooltips[e.features[0].id]){
			this.tooltips[e.features[0].id].remove();
			delete this.tooltips[e.features[0].id];
		}
		// handle deletions first
		// handle deletions first
		if (e.type == 'draw.delete' && this.lastSelection && this.lastSelection.id == e.features[0].id && this.lastSelection.type == 'road'){
			this.handleRDUpdate(tc, this.lastSelection.id, true);
			this.lastSelection = null;
			return;
		}
		const data = this.draw.getAll();
		//it's a new boundary polygon
		if (e.type == 'draw.create' && e.features && e.features[0].id == 'added_boundary'){
			if(updateFunction)
				updateFunction(e.features[0].geometry);
			
			return;
		}
		if (e.type == 'draw.create' && e.features && ['added_cable', 'added_road', 'added_measure'].includes(e.features[0].id)){
			//powerlines have their own handler;
			return;
		}
		if (e.type == 'draw.update' && e.features && ['added_cable', 'added_road', 'added_measure'].includes(e.features[0].id)){
			//powerlines have their own handler;
			return;
		}
		// it's a new drawn polygon
		else if(e.type == 'draw.create'){
			//test adding colors
			this.draw.setFeatureProperty(e.features[0].id, "color", this.currentColor);
			this.draw.setFeatureProperty(e.features[0].id, "thickness", this.currentThickness);
		}
		
		if (data.features.length > 0) {
			//redraw all tooltip, eventualy we can just draw for the last feature added
			Object.entries(this.tooltips).forEach((k)=>{
				k[1].remove();
			})
			this.tooltips = {};
			this.boundary = [];
			data.features.forEach((feature)=>{
				
				//check if the feature is a boundary, save boundary and return, boundary doesn't have a tooltip
				if(feature.properties.drawType == 'boundary'){
					//update the boundary in the main instance
					//feature as the index property for the coordinates array of the geometry
					this.boundary.push(feature.geometry.coordinates);

					return;
				}
				if(feature.properties && ['cable', 'road', 'measure'].includes(feature.properties.type)){
					//powerline was upd

					return;
				}
				//check of the feature has coordinates, trashing while updating returns empty feature
//				if(feature.geometry.coordinates[0]){
//					if(feature.geometry.type == "Polygon"){
//						var pin = feature.geometry.coordinates[0][0];
//						var measurement = this.formatArea(TurfArea(feature));
//					}
//					else{
//						//is LineString
//						var pin = feature.geometry.coordinates[feature.geometry.coordinates.length-1];
//						var measurement = this.formatDistance(TurfLength(feature, {units: 'meters'}));
//					}
//
//					this.tooltips[feature.id] = new mapboxgl.Popup({ closeOnClick: false })
//					.setLngLat(pin)
//					.setHTML(measurement)
//					.addTo(this.map);
//				}
			});
		}
		//if it arrives here it's draw.update || draw.delete
		if(e.features && e.features.length && e.features[0].properties.drawType == 'boundary' && updateFunction)
			updateFunction({
				boundary:{
					geometry:{
						coordinates: this.boundary,
						type: "MultiPolygon"		
					}
				}
			});
		//console.log(this.draw.getAll());
	}
	//this handler is necessary for the cases where the click is in the 2px bufferzone outside the draw layer
	handleSelectionChange(tc, setPwrRdsPanel, e){	
		//var features = this.map.queryRenderedFeatures(e.point);
		if(!tc || !tc.scenario || !tc.scenario.scenario_id || this.map.disableEvents //check if is main scenario
		){
			this.draw.changeMode('simple_select');
		}
		//check if powerline is selected
		if (e.features.length && e.features[0].properties && ['cable', 'road'].includes(e.features[0].properties.type) ){
			this.lastSelection = {id: e.features[0].id, type: e.features[0].properties.type};
			return;
		}
		//check if powerline is deselected
		if (this.lastSelection){
			return this.finishLastEdit(tc, setPwrRdsPanel, e);
		}
		
		if(e.features.length &&  !["boundary", "cable", "road"].includes(e.features[0].properties.drawType) && this.draw.getMode() == "simple_select"){
			//activate drawing options panel
			this.showOptionsPanel();
			if(this.dop)
				this.dop.setState({color:e.features[0].properties.color,thickness:e.features[0].properties.thickness})
			this.currentSelectedDrawing = e.features[0].id;
		}
		else{
			
			this.hideOptionsPanel();
			//deactivate drawing options panel
			this.currentSelectedDrawing = null;
		}
	}

	handleTurbineClick = (marker)=>{
		
		//if we are currently in delete mode, we don't show turbine detail
		if(this.map.getContainer().classList.contains("cursor-delete-turbine"))
			return;
		var a = new ToolTurbineDetail(this.tc, marker.dataset.turbineid);
		
	}
	handleTurbineEnter = (e) => {
		e.stopPropagation();
		if(!this.tc.handler) // not in turbine mode
			return;
		
		
		const turbineId = e.target.parentNode.dataset.turbineid;
		
		e.target.parentNode.classList.add("active");
		
		this.tc.handler.highlightOnList(turbineId);
		
	}
	handleTurbineLeave = (e) => {
		e.stopPropagation();
		if(!this.tc.handler) // not in turbine mode
			return;
		
		const turbineId = e.target.parentNode.dataset.turbineid;
		
		e.target.parentNode.classList.remove("active");
		
		this.tc.handler.deHighlightOnList(turbineId);
		
	}
	getEnergyIcon(energy){
		var icons = {
			"Solar" : "solar-marker",
			"Wind" : "wtg-marker"
		}
		if(icons[energy])
			return icons[energy];
		return icons["Wind"];
	}
	
	drawProjects(projects){
		
		this.clearTurbines();
		this.clearMarkers();
		
		projects.forEach((feature)=>{
			
			const pop = '<div class="row"><div class="col-12">'+feature.name + ' (' + feature.state + ')' +'</div><div class="col-6"><i class="ri-user-fill"></i> '+feature.owners+'</div><div class="col-6"><i class="ri-rounded-corner"></i> '+feature.size.toFixed(2)+' km<sup>2</sup></div></div>';
			
			
			const el = document.createElement('div');
			el.className = this.getEnergyIcon(feature.energyType);
			el.innerHTML = pop;
			el.onclick = ()=>{
				window.location.href='/pages/project/'+feature.projectid+'/';
			}
  
			const marker = new clickableMarker({
				draggable: false,
				element:el,
				anchor:'bottom'
			})
			.setLngLat([feature.lon, feature.lat])
			.addTo(this.map);
			this.markers.push(marker);
		});	
	}
	clearMarkers(){
		
		
		this.markers.forEach((m)=>{
			m.remove();
		});
		this.markers = [];
	}
	alignCamera(rads){
		
		var azimute = parseInt(this.previousPhotoMarker.dataset.pan)-90 + rads2deg(rads);  //icon is facing right;
		
		this.photos[this.previousPhotoMarker.dataset.idx].marker.setRotation(azimute);
		
	}
	drawPhotos(scenario, setFn, cont){
		
		if(!scenario.images)
			return;
		//this.clearTurbines();
		var self = this;
		var idx = 0;
		scenario.images.forEach((image)=>{
			

			const el = document.createElement('div');
			el.className = 'image-dot';
			el.innerHTML = '<i class="ri-circle-fill" data-idx="'+idx+'" data-pan="'+image.pan+'"></i> ';
			el.onclick = (e)=>{
				e.preventDefault();
				e.stopPropagation();
				if(self.previousPhotoMarker)
					self.previousPhotoMarker.classList.replace("ri-vidicon-fill", "ri-circle-fill");
				
				e.target.classList.replace("ri-circle-fill", "ri-vidicon-fill");
				self.previousPhotoMarker = e.target;
				setFn({url:image.url});
				
				cont.current.setPanorama(image.url);
				cont.current.rotate({yaw:0,pitch:0});
				self.photos.forEach((a)=>a.marker.setRotation(parseInt(a.image.pan)-90));
				self.map.once("click", ()=>{setFn({});self.previousPhotoMarker.classList.replace("ri-vidicon-fill", "ri-circle-fill");setTimeout(()=>{self.map.resize();}, 200);});
				setTimeout(()=>{self.map.resize();}, 200);
			};
  
			const marker = new clickableMarker({
				draggable: false,
				element:el,
				anchor:'bottom'
			})
			.setLngLat([image.lon, image.lat])
			.addTo(this.map);

			this.photos[idx++] = {
				image: image,
				marker: marker
			}

		});	
	}
	closePhotos(setFn){
		
		//this.clearTurbines();
		var self = this;
		
		if(self.previousPhotoMarker)
			self.previousPhotoMarker.classList.replace("ri-vidicon-fill", "ri-circle-fill");
		
		setFn({});
		
		setTimeout(()=>{self.map.resize();}, 200);
		
	}
	addTurbineName(turbine, tc, scenario){
		var input = document.createElement('span');
		input.contentEditable = scenario.scenario_id ? "true" : "false";
		input.innerText = turbine.name ? turbine.name : 'Turbine '+turbine.turbineid;
		input.className = "wtg-input";
		input.onclick = (e)=>{e.stopPropagation(); e.target.focus()};
		input.ondblclick = (e)=>{e.stopPropagation(); e.target.focus()};
		input.onkeydown = input.ondrag = input.ondragstart = input.onmousedown = (e)=>{e.stopPropagation();};
		input.dataset.turbineid = turbine.turbineid;
		input.onblur = (e)=>{tc.updateTurbineName(e.target.innerText, e.target.dataset.turbineid);}
		
		const el = document.createElement('div');
		el.className = 'wtg-marker-name';
		el.appendChild(input);
		return el;
	}
	updateTurbineName(name, id){
		
		
		
	}



//	drawEllipses(turbines, project){
//		
//		if(project)
//			this.projectData = project
//		this.clearEllipses();
//		this.ellipsesOrientation = this.projectData.wind_direction;
//		var data = {
//			"type":"FeatureCollection",
//			"features":[]
//		};
//		turbines.forEach((turbine)=>{
//			//check if turbine was deleted
//			if(!turbine.geometry)
//				return;
//			
//			this.ellipses.push(turbine.turbineid);
//			var ellipse_geometry = this.generateEllipse(turbine.geometry.coordinates, this.projectData);
//			ellipse_geometry.features[0].properties.turbineid = turbine.turbineid
//			
//			data.features.push(ellipse_geometry.features[0]);
//			
//		});	
//
//		this.map.addSource('ellipses_source', {
//			'type': 'geojson',
//			'data': data
//		});
//
//		// Add a new layer to visualize the polygon.
//		this.map.addLayer({
//			'id': 'ellipses',
//			'type': 'line',
//			'source': 'ellipses_source', // reference the data source
//			'layout': {
//					'visibility' : this.map.layerStatus['turbines'] ? 'visible' : 'none'
//			},
//			'paint': {
//				'line-color': '#FF6E6E',
//				'line-width': 1.5
//			}
//		});
//		this.ellipses = data;
//	}
	drawCircles(scenario){
		
		if(!scenario)
			return;
		this.clearCircles();
		var idx;
		
		const circles = structuredClone(scenario.wtgSettings.circles);
		
		circles.forEach((circle)=>{
			//check if turbine was deleted
			
			const key = circle.id;
			
			if(!circle.visible)
				return;
			
			var data = {
				"type":"FeatureCollection",
				"features":[]
			};
			
			
			//mudar isto para this.cicles.find e colocar o turbineid numa prop do objecto
			
			scenario.wtgs.forEach((turbine)=>{
			
				if(!turbine.geometry)
					return;
				
				var circle_geometry = this.generateCircle(turbine.geometry.coordinates, circle.radius);
				
				circle_geometry.features[0].properties.turbineid	= turbine.turbineid;
				circle_geometry.features[0].properties.circleid		= circle.id;
				circle_geometry.features[0].properties.name			= circle.name;
				circle_geometry.features[0].properties.color		= circle.color;
				
				data.features.push(circle_geometry.features[0]);				
				
			});
			
			this.circles[key] = {
				info: circle,
				data: data
			};

			this.map.addSource(LayerCircles.sourceId+key, {
				'type': 'geojson',
				'data': data
			});

			// Add a new layer to visualize the polygon.
			this.map.addLayer({
				'id': LayerCircles.layerId+key,
				'type': 'line',
				'source': LayerCircles.sourceId+key, // reference the data source
				'layout': {
					'visibility' : this.map.layerStatus['turbines'] ? 'visible' : 'none'
				},
				'paint': {
					'line-color': ['get', 'color'],
					'line-width': 1.5
				}
			});

			this.map.addLayer({
				'id': LayerCircles.textLayerId+key,
				'type': 'symbol',
				'source': LayerCircles.sourceId+key,
				"paint": {
					'text-color': ['get', 'color'], //Color of your choice
					'text-opacity': 1,
					'text-halo-color': "#ffffff",
					'text-halo-width': 3,
					'text-halo-blur': 0
				}, // reference the data source
				'layout': {
					'text-field': ['get', 'name'], //This will get "t" property from your geojson
					'text-rotation-alignment': "auto",
					'text-allow-overlap': true,
					'text-anchor': "top",
					'text-size': 14,
					'symbol-placement': 'line-center',
					'text-ignore-placement': true
				},
			});
			

		});	
	}
	updateCircleColor(id, color){
		var source = this.tc.map.getSource(LayerCircles.sourceId+id);
		if(!source) return;
		var data = source._options.data;

		data.features.forEach((c)=>{
			c.properties.color = color;
		});

		source.setData(data);

	}
	drawPowerLines(scenario, tc){
		
		//this.powerlineHandler = new LayerCable(this, scenario, tc);	
	}

	drawTurbines(scenario, tc){
		this.turbineHandler = new LayerTurbine(this, scenario, tc);	
	}
	drawRoads(scenario, tc){
		
		this.roadsHandler = new LayerRoad(this, scenario, tc);	
		
	}
	toggleTurbineMarkers(show){
		this.map.layerStatus['ellipses'] = show;
		this.map.getContainer().classList[show?'remove':'add']("hide-turbines");
		return true;
	}
	toggleTurbines(show){
		this.map.layerStatus['turbines'] = show;
		return this.getTurbineRelatedLayerIds();
	}
	toggleTurbineNames(show){
		this.map.layerStatus['turbineNames'] = show;
		this.map.getContainer().classList[show?'add':'remove']("show-turbineNames");
		return true;
	}
	getTurbineRelatedLayerIds(){
		
		var ids = [
			'ellipses',
			...this.circles.map((circle, key)=>{
				return 'circles_'+key;
			})
		];
		
		return ids;
	}
	clearTurbines(){
		this.turbines.forEach((turbine) => {
			turbine.remove();
		});
		this.turbines = [];
	}
	clearEllipses(){
		if(this.map.getLayer('ellipses')){
			this.map.removeLayer('ellipses');
			this.map.removeSource('ellipses_source');
		}
		
		this.ellipses = [];
	}
	clearCircles(){

		this.circles.forEach((circle, key) => {
			if(this.map.getLayer(LayerCircles.layerId+key)){
				this.map.removeLayer(LayerCircles.layerId+key);
				this.map.removeLayer(LayerCircles.textLayerId+key);
				this.map.removeSource(LayerCircles.sourceId+key);
			}
		});
		this.circles = [];
	}
	removeCircle(scenario, circleid){
		
		scenario.wtgSettings.circles = scenario.wtgSettings.circles.filter(function( obj ) {
			return obj.circleid !== circleid;
		});
		
		this.drawCircles(scenario);
	}
	highLightCircle(circleid, thickness){
		this.circles.forEach((turbine) => {
			this.map.setPaintProperty('turbine_'+turbine.turbineid+'_'+circleid, 'line-width', thickness);
		});	
	}
//	generateEllipse(center, project) { //radius in meters
//		
//		var longRadius = project.long_turbine_radius; // radius in meters
//		var shortRadius = project.short_turbine_radius;
//		//i am adding 90 degrees to the orientation, TurfEllipse with 0 degrees, creates a ellipse in "landscape" orientation
//		return PolySmooth(TurfEllipse(center, longRadius, shortRadius, {steps:128, units:'meters', angle:project.wind_direction+90}), {});
//	};
	generateCircle(center, radius) { //radius in meters
		//i am adding 90 degrees to the orientation, TurfEllipse with 0 degrees, creates a ellipse in "landscape" orientation
		return PolySmooth(TurfCircle(center, radius, {steps:128, units:'meters'}), {});
	};
	isBoundaryFill(features){
		
		var out = features.filter(feature=>feature && feature.layer.type == 'fill' && feature.properties.id == 'boundary');
		return out.length ;
		
	}
	isBoundaryStroke(features){
		
		var out = features.filter(feature=>feature && feature.layer.type == 'line' && feature.properties.id == 'boundary');
		return out.length ;
		
	}
	stackLayer(layerId, layerAbove){
		
		const lAbv = layerAbove ? layerAbove : 'gl-draw-polygon-fill-inactive.cold';
		if(this.map.getLayer(lAbv))
			this.map.moveLayer(layerId, lAbv);	
		
		this.stackProjectLayer();
			
	}
	stackProjectLayer(){
		if(this.map.getLayer('gl-draw-polygon-fill-inactive.cold')){
			['project-geojson-fill', 'project-geojson-stroke'].forEach((l)=>{
				this.map.moveLayer(l, 'gl-draw-polygon-fill-inactive.cold');
			});
		}
	}
	
	setColor(color){
		this.currentColor = color;
		this.updateDrawing();
	}
	setThickness(thickness){
		this.currentThickness = thickness;
		this.updateDrawing();
	}
	updateDrawing(){
		if(this.currentSelectedDrawing){
			this.draw.setFeatureProperty(this.currentSelectedDrawing, "color", this.currentColor);
			this.draw.setFeatureProperty(this.currentSelectedDrawing, "thickness", this.currentThickness);
			
			//we do this to update the color in real time while the polygon is selected
			this.draw.changeMode(this.draw.getMode(), {featureIds:this.currentSelectedDrawing, featureId:this.currentSelectedDrawing});
		}
	}
	setOpacity(opc, layer){
		var cl = layer ? layer : this.currentSelectedLayer;
		
		if(cl){
			var layers = cl.layer.split(",");
			layers.forEach((l)=>{
				this.setLayerOpacity(l, opc);
			});
			cl.opacity = opc;
		}
	}
	setLayerOpacity(l, opacity){
		if(l && opacity !== null){
			var opc = parseFloat(opacity);
			var layer = this.map.getLayer(l);
			//console.log(layer.type);
			if(!layer)
				return;
			
			if (layer.type === 'symbol')  {
				this.map.setPaintProperty(l, 'icon-opacity', opc);
				this.map.setPaintProperty(l, 'text-opacity', opc);
			}
			else if(layer.type === 'raster') {
				this.map.setPaintProperty(l, layer.type+'-opacity', opc);
			}
			else {
				var op = ['case',
					['boolean', ['feature-state', 'invisible'], false],0,
					opc
				];
				this.map.setPaintProperty(l, layer.type+'-opacity', op);
			}
		}
	}
	showOptionsPanel(){
		//.dop is assigned when DrawOptionsPanel compoenent is rendered
		if(this.dop.optionsPanel.current)
			this.dop.optionsPanel.current.classList.replace("d-none", "d-block");
	}
	hideOptionsPanel(){
		if(this.dop && this.dop.optionsPanel.current)
			this.dop.optionsPanel.current.classList.replace("d-block", "d-none");
	}
	
	drawOptionsPanel(){
		return (
			<DrawOptionsPanel du={this} color={this.currentColor} thickness={this.currentThickness} onColorChange={(color)=>{this.setColor(color)}} onThicknessChange={(t)=>{this.setThickness(t)}} />	
		)
	}
	setRangeOpacity(){
		if(this.currentSelectedLayer){
			//get the current opacity of a layer or input
			var l = this.currentSelectedLayer.layer.split(",")[0];
			var layer = this.map.getLayer(l);
			var opacity = null;
			if(this.currentSelectedLayer.opacity)
				opacity = this.currentSelectedLayer.opacity;
			else if(layer.type === 'symbol')
				opacity = this.map.getPaintProperty(l, 'text-opacity') ? this.map.getPaintProperty(l, 'text-opacity') : this.map.getPaintProperty(l, 'icon-opacity');
			else
				opacity = this.map.getPaintProperty(l, layer.type+'-opacity');
			

			opacity = opacity ? opacity : 1;
			this.op.setOpacity(opacity);
			
		}
	}
	setOpLegend(){
		this.op.setLegend(this.currentLayerLegend);
	}
	drawOpacityPanel(){
		return (
			<OpacityPanel du={this} onOpacityChange={(opacity)=>{this.setOpacity(opacity)}} />	
		)
	}
	syncLayerOpacity(){
		document.querySelectorAll('.nav-sidebar.layers').forEach((s)=>{
			s.querySelectorAll('INPUT[type=checkbox]').forEach((i)=>{
				if(i.dataset.layer && i.dataset.opacity){
					this.setOpacity(i.dataset.opacity, i.dataset);
				}
			});
		}) 
	}
	reset(){
		if(this.map.hasControl(this.draw))
			this.draw.deleteAll();
	}
	
	getProjectNow(projectId, scenarioId, user){
		
		const dataRequests = [
			vindrApi.getProject(projectId, user.userDetails),
			vindrApi.getScenario(projectId,scenarioId,0, 'default'),
		];
		
		return Promise.all(dataRequests)
		
	}
	
	getPropertiesGeoJson(scenario, user){
		
		const self = this;
		const projectId = scenario.projectid;
		const scenarioId = scenario.scenario_id ?? scenario.scenarioid;
		
		return this.getProjectNow(projectId, scenarioId, user).then((res)=>{
			const fetchedProject = res[0];
			const fetchedScenario = res[1];

			return [self.filenamify(fetchedProject.name)+"_properties.geojson", JSON.stringify(fetchedScenario.properties)];
		}) ;
		
	}
	getPropertiesCsv(scenario, user){
		
		const self = this;
		const projectId = scenario.projectid;
		const scenarioId = scenario.scenario_id ?? scenario.scenarioid;
		
		
		return this.getProjectNow(projectId, scenarioId, user).then((res)=>{
			const fetchedProject = res[0];
			const fetchedScenario = res[1];


			var lines = [];

			if(fetchedScenario.landowners.length){
				var props = Object.keys(fetchedScenario.landowners[0]).filter((p)=>p!="properties");
				var line = ["propertyId"];
				//add csv header line
				props.forEach((prop)=>{
					line.push(prop);
				});
				lines.push('"'+line.join('";"')+'"');
			}

			var exported = [];

			fetchedScenario.properties.features.forEach((p)=>{


				if(exported.includes(p.properties.vindrid))
					return;



				var line = [
					p.properties.vindrid,
				]
				//check if the property has any landowner
				var found = false;
				fetchedScenario.landowners.forEach((o)=>{
					if(found)
						return;
					var idx = o.properties.findIndex((op)=>p.properties.vindrid == op.id);
					if(idx>-1){
						props.forEach((prop)=>{
							line.push(o[prop]);
						});
						found = true;
						return;
					}

				});
				if(!found && props && props.length)
					props.forEach((prop)=>{
						line.push("");
					});

				lines.push('"'+line.join('";"')+'"');
			});





			return [self.filenamify(fetchedProject.name)+"_properties_csv.csv", lines.join("\n")];


		}) ;
		
		
	}
	getLandownersCsv(scenario, user){
		
		const self = this;
		const projectId = scenario.projectid;
		const scenarioId = scenario.scenario_id ?? scenario.scenarioid;
		
		return this.getProjectNow(projectId, scenarioId, user).then((res)=>{
			const fetchedProject = res[0];
			const fetchedScenario = res[1];

			var lines = [];

			if(fetchedScenario.landowners.length){
				var props = Object.keys(fetchedScenario.landowners[0]).filter((p)=>!["properties", "dialogs"].includes(p));
				props.push("properties");
				var line = [];
				//add csv header line
				props.forEach((prop)=>{
					line.push(prop);
				});
				lines.push('"'+line.join('";"')+'"');
			}

			fetchedScenario.landowners.forEach((o)=>{

				var line = [];

				props.forEach((prop)=>{
					if(prop == "properties" && o[prop].length) {
						line.push(o[prop].map((a)=>a.id).join(", "));
					}
					else {
						line.push(o[prop]);
					}
				});
				lines.push('"'+line.join('";"')+'"');
			});

			return [self.filenamify(fetchedProject.name)+"_landowners_csv.csv", lines.join("\n")];

		}) ;
		
		
		
	}
	getBoundaryGeoJson(){
		return [this.filenamify(this.context.getters.project.name)+"_boundary.geojson", JSON.stringify(this.draw.get("boundary"))];
	}
	getRoadsGeoJson(){
		if(this.map.getSource("rd_source"))
			return [this.filenamify(this.context.getters.project.name)+"_roads.geojson", JSON.stringify(this.map.getSource("rd_source")._data)];
	}
	getPowerLinesGeoJson(){
		if(this.map.getSource("pl_source"))
			return [this.filenamify(this.context.getters.project.name)+"_cables.geojson", JSON.stringify(this.map.getSource("pl_source")._data)];
	}
	getScreenshot(){
		document.querySelector(".map-wrapper").classList.add("screenshot");
		
		return html2canvas(document.querySelector(".map-wrapper")).then(function(canvas) {
			var ret =  canvas.toDataURL().split(';base64,')[1];
			document.querySelector(".map-wrapper").classList.remove("screenshot");
			return ret;
		});
		//return this.map.getCanvas().toDataURL().split(';base64,')[1];
		
	}
	getTurbinesGeoJson(scenario){
		if(scenario && scenario.wtgs){
			var copy = scenario.wtgs.slice(0);
			var geojson = {  
				"type":"FeatureCollection",
				"features": copy.map((t)=>{
					t.type = "Feature";
					t.properties  = {}
					t.properties.turbineid = t.turbineid;
					delete t.turbine_id
					return t;
				})
			}
			return [this.filenamify(this.context.getters.project.name)+"_turbines.geojson", JSON.stringify(geojson)];	
			
		}
	}
	
	getProjectFile(scenario, fileFormat){
		return vindrApi.downloadProjectFile(this.context.getters.project.projectid, scenario.scenario_id ?? scenario.scenarioid, {format:fileFormat});
	}
	getProjectShapefile(scenario){
		return this.getProjectFile(scenario, "shapefile");
	}
	getProjectGeojson(scenario){
		return this.getProjectFile(scenario, "geojson");
	}
	getProjectCSV(scenario){
		return this.getProjectFile(scenario, "csv");
	}
	getProjectExcel(scenario){
		return this.getProjectFile(scenario, "excel");
	}
	getProjectGeopackage(scenario){
		return this.getProjectFile(scenario, "geopackage");
	}
	
	getProjectDXF(scenario){
		return this.getProjectFile(scenario, "dxf");
	}
	getProjectOWS(scenario){
		return this.getProjectFile(scenario, "ows");
	}
	filenamify(s){
		return s.replace(/[^a-z0-9]/gi, '_').toLowerCase();
	}
	
	disableDraw(){
		document.querySelectorAll(".mapbox-gl-draw_ctrl-draw-btn").forEach((e)=>{
			e.disabled = true;
			e.classList.add("disabled");
		});
	}
	enableDraw(){
		document.querySelectorAll(".mapbox-gl-draw_ctrl-draw-btn").forEach((e)=>{
			e.disabled = false;
			e.classList.remove("disabled");
		});
	}
	onContextMenu(e){
		
		const {QN} = this.context;
		
		//don't show coordinates when we are in turbine mode
		if(this.tc.handler)
			return;
		
		e.preventDefault();
		var self = this;
		const popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: true,
			className:"popup-coords-wrp"
        });
		if(this.popup){
			this.popup.remove();
		}
		
		
		popup.setLngLat(e.lngLat).setHTML('<span class="popup-coords" title="Copy to clipboard">'+String(e.lngLat.lat).slice(0,7)+', '+String(e.lngLat.lng).slice(0,7)+'</span>').addTo(this.map);
		
		popup.on("close", ()=>{
			self.popup = null;
		});
		popup.getElement().addEventListener("click", ()=>{
			navigator.clipboard.writeText(e.lngLat.lat+', '+e.lngLat.lng);
			QN.current.show("Coordinates copied to clipboard");
			popup.remove();
		})
		this.popup = popup;
		
		return false;
	}
	setContextMenu(){
		
		this.map.on("contextmenu", this.onContextMenu.bind(this));
		
		
	}
	
}
export { drawUtils };
